import React from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../../data/services-data';
import ctaImage from '../../../assets/img/page/cta-1.jpg';
import image1 from '../../../assets/img/portfolio/portfolio-1.jpg';
import image2 from '../../../assets/img/portfolio/portfolio-2.jpg';

const ServicesConsultancy = () => {
    return (
        <>
            <div className="services__details section-padding">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-4 columns_sticky">
                            <div className="all__sidebar">                        
                                <div className="all__sidebar-item">
                                    <h4>Our Solutions</h4>
                                    <div className="all__sidebar-item-category">
                                        <ul>
                                            {servicesData.slice(0, 5).map((data, id) => (
                                                <li key={id}><Link to={`/services/${data.id}`}>{data.title}<i className="flaticon-right-up"></i></Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="all__sidebar-item-help mb-25" style={{backgroundImage: `url(${ctaImage})`}}>
                                    <h3>Ready for Your Next Construction?</h3>
                                    <Link className="build_button mt-20" to="/contact-us">Get an Advice<i className="flaticon-right-up"></i></Link>
                                </div>
                                <div className="all__sidebar-item">
                                    <h4>Download</h4>
                                    <div className="all__sidebar-item-download">
                                        <ul>
                                            <li><Link to="#">Company Details<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                            <li><Link to="#">Our Brochures<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                        </ul>                            
                                    </div>
                                </div>
                            </div>  
                        </div> */}
                        <div className="col-lg-12">
                            <div className="services__details-area">
                                {/* <img src={singleData.image} alt="image" /> */}
                                {/* <h3 className="mt-25 mb-20">{servicesData.title}</h3> */}
                                <h2 className="mb-20">At <span style={{color: "#007bff"}}>The EngineersBay</span></h2>
                                <p className="mb-20">
                                    We don’t just build structures—we build trust, innovation, and sustainable solutions. With expertise spanning architectural design, construction management, soil testing, and import &amp; supply, we provide complete consultancy services under one roof.
                                </p>

                                <div className="row mt-40 mb-40">
                                    <div className="col-sm-6 sm-mb-25">
                                        <img className="img_full" src={image1} alt="image" />
                                    </div>
                                    <div className="col-sm-6">
                                        <img className="img_full" src={image2} alt="image" />
                                    </div>
                                </div>
                                <h3 className="mb-20">1. Architectural Consultancy</h3>
                                <p className="mb-20">
                                    Our architectural consultancy transforms ideas into reality with creativity and precision.
                                </p>
                                <ul className="mb-20">
                                    <li><strong>Conceptual Design &amp; Master Planning</strong> – Tailored layouts that balance functionality and aesthetics.</li>
                                    <li><strong>3D Visualization &amp; Rendering</strong> – Helping clients see their future projects before construction.</li>
                                    <li><strong>Interior &amp; Exterior Design</strong> – Modern, sustainable, and client-centric solutions.</li>
                                    <li><strong>Regulatory Approvals</strong> – Guidance and preparation of drawings for government and authority approval.</li>
                                </ul>
                                <p className="mb-20">
                                    We focus on delivering innovative, eco-friendly, and cost-effective designs that suit both residential and commercial needs.
                                </p>

                                <h3 className="mb-20">2. Construction Consultancy</h3>
                                <p className="mb-20">
                                    We bring projects to life with robust construction strategies and on-site guidance.
                                </p>
                                <ul className="mb-20">
                                    <li><strong>Project Planning &amp; Cost Estimation</strong> – Transparent budgeting and financial planning.</li>
                                    <li><strong>Structural Supervision</strong> – Ensuring quality and safety at every stage.</li>
                                    <li><strong>Contractor Selection &amp; Bidding Support</strong> – Helping you find the right builders.</li>
                                    <li><strong>Project Monitoring &amp; Quality Control</strong> – Timely updates, site visits, and technical reporting.</li>
                                </ul>
                                <p className="mb-20">
                                    Our consultancy ensures projects are completed on time, within budget, and with uncompromising quality.
                                </p>

                                <h3 className="mb-20">3. Soil Test &amp; Geotechnical Consultancy</h3>
                                <p className="mb-20">
                                    Strong foundations start with strong soil. Our soil testing consultancy ensures your project is safe and durable.
                                </p>
                                <ul className="mb-20">
                                    <li><strong>Site Investigation &amp; Soil Testing</strong> – Borehole drilling, lab analysis, and soil classification.</li>
                                    <li><strong>Load Bearing Capacity Reports</strong> – Critical for structural safety and design.</li>
                                    <li><strong>Foundation Design Recommendations</strong> – Expert guidance to avoid settlement or structural issues.</li>
                                    <li><strong>Geotechnical Risk Assessment</strong> – Identifying challenges like groundwater, soft soil, or seismic risks.</li>
                                </ul>
                                <p className="mb-20">
                                    We deliver accurate data that empowers architects, engineers, and builders to make the right decisions.
                                </p>

                                <h3 className="mb-20">4. Import &amp; Supply Consultancy</h3>
                                <p className="mb-20">
                                    We support your project with reliable sourcing and supply chain solutions.
                                </p>
                                <ul className="mb-20">
                                    <li><strong>Construction Materials Supply</strong> – Cement, steel, aggregates, finishing items.</li>
                                    <li><strong>Specialized Equipment &amp; Machinery</strong> – Import and delivery of high-quality construction equipment.</li>
                                    <li><strong>International Sourcing</strong> – Finding the best products from global markets.</li>
                                    <li><strong>Logistics &amp; Cost Management</strong> – Ensuring timely delivery at competitive prices.</li>
                                </ul>
                                <p className="mb-20">
                                    Our consultancy ensures your project has access to top-quality materials and equipment, on time and within budget.
                                </p>

                                <h3 className="mb-20">Why Choose Us?</h3>
                                <ul className="mb-20">
                                    <li><strong>One-Stop Solution</strong> – From design to delivery, all under one roof.</li>
                                    <li><strong>Expert Team</strong> – Skilled architects, engineers, geotechnical specialists, and supply professionals.</li>
                                    <li><strong>Client-Centric Approach</strong> – Transparent, reliable, and focused on your success.</li>
                                    <li><strong>Proven Track Record</strong> – Successful delivery of residential, commercial, and industrial projects.</li>
                                </ul>
                                <p className="mb-20">
                                    At The Engineersbay Ltd, we are more than consultants—we are your strategic partner in growth and development.
                                </p>
                                <p className="mb-20">
                                    <strong>Let’s build the future together. Contact us today to explore how our consultancy can make your project a success.</strong>
                                </p>

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </>
    );
};

export default ServicesConsultancy;